__turbopack_context__.v({
  "active": "_9Tvq4W_active",
  "block": "_9Tvq4W_block",
  "colors": "_9Tvq4W_colors",
  "contacts": "_9Tvq4W_contacts",
  "content": "_9Tvq4W_content",
  "disabled": "_9Tvq4W_disabled",
  "footer": "_9Tvq4W_footer",
  "form": "_9Tvq4W_form",
  "info-error-container": "_9Tvq4W_info-error-container",
  "input-rows": "_9Tvq4W_input-rows",
  "lable-title": "_9Tvq4W_lable-title",
  "layout": "_9Tvq4W_layout",
  "lottie": "_9Tvq4W_lottie",
  "redeemCard": "_9Tvq4W_redeemCard",
  "row": "_9Tvq4W_row",
  "select-wrapper": "_9Tvq4W_select-wrapper",
  "sizes": "_9Tvq4W_sizes",
  "submit": "_9Tvq4W_submit",
  "success-block": "_9Tvq4W_success-block",
  "text-description": "_9Tvq4W_text-description",
});
